import type {
  CreateFacilityPayload,
  CreateFacilityResponse,
  DeleteFacilityResponse,
  FacilityDetailResponse,
  FacilityEndpointResponse,
  FacilityID,
  FacilityListResponse,
  UpdateFacilityParams,
  UpdateFacilityPayload,
  UpdateFacilityResponse,
} from '@/domains/asset-management/types/facility';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

const toUrlID = (id: string | number): string => String(id);

export const fetchFacilityList = async (params: string = ''): Promise<FacilityListResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.facilityList(params)}`;
  return await request.get(url);
};

export const fetchDetailFacility = async (fcID: FacilityID): Promise<FacilityDetailResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.detailFacility(toUrlID(fcID))}`;
  return await request.get(url);
};

export const deleteFacility = async (fcID: FacilityID): Promise<DeleteFacilityResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.deleteFacility(toUrlID(fcID))}`;
  return await request.delete(url);
};

export const createFacility = async (
  facilityData: CreateFacilityPayload
): Promise<CreateFacilityResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.createFacility}`;
  return await request.post(url, facilityData);
};

export const updateFacility = async (
  facilityData: UpdateFacilityPayload,
  params: UpdateFacilityParams
): Promise<UpdateFacilityResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.updateFacility(toUrlID(params.facility_id))}`;
  return await request.put(url, facilityData);
};

export const fetchFacilityEndpoints = async (
  facilityType?: string
): Promise<FacilityEndpointResponse> => {
  const params = facilityType ? `?facility_type=${facilityType}` : '';
  const url = `${URLS.BACK_DSH}/facility/endpoint${params}`;
  return await request.get(url);
};
